export default "__VITE_ASSET__4d22498a__"